import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col, ButtonToolbar } from 'react-bootstrap';

import FAIcon from '../FAIcon.jsx';

import '../css/DeleteEventModal.css';

const DeleteEventModal = ({ showDeleteConfirm, onYesClick, onNoClick, event }) => (
  <Modal show={showDeleteConfirm} className="inmodal">
    <Modal.Header>
      <Modal.Title>Poista harjoitus</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col md={4} className="warningIcon">
          <span className="warning-icon text-danger">
            <FAIcon icon="warning" />
          </span>
        </Col>
        <Col md={8} className="warningDescriptionDelete">
          <h2>Poistetaanko harjoitus?</h2>
        </Col>
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <ButtonToolbar className="pull-right">
        <Button bsStyle="danger" bsSize="large" onClick={onYesClick}>Kyllä</Button>
        <Button bsSize="large" onClick={onNoClick}>Ei</Button>
      </ButtonToolbar>
    </Modal.Footer>
  </Modal>
);

DeleteEventModal.propTypes = {
  showDeleteConfirm: PropTypes.bool.isRequired,
  onYesClick: PropTypes.func.isRequired,
  onNoClick: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired
};

export default DeleteEventModal;



// WEBPACK FOOTER //
// ./src/components/eventDetails/DeleteEventModal.jsx